<template>
  <Card :title="$t('global.service')">
    <template v-if="loading">
      <LoadingState :size="50" style="height: 100px;" />
    </template>

    <template v-else>
      <CardActionContent :title="`${$t('global.plan-name')}: ${plan.package.name}`" />

      <hr />

      <table class="plan-metrics">
        <!-- disk space metrics -->
        <tr class="my-2">
          <th class="h2">{{ $t("global.disk-space") }}:</th>
          <td>
            <div class="progress bg-transparent position-relative">
              <div
                class="progress-bar percentage"
                role="progressbar"
                :style="`width:${getDiskSpacePercentage()}%`"
                :aria-valuenow="getDiskSpacePercentage()"
                aria-valuemin="0"
                aria-valuemax="100"
              />
              <div class="mt-3 justify-content-center d-flex position-absolute w-100">
                {{
                  $t("global.units-out-of-total", {
                    amount: usageMetrics.storageUsedGb + " GB",
                    total: usageMetrics.storageTotalGb + " GB",
                  })
                }}
              </div>
            </div>
          </td>
        </tr>

        <!-- bandwidth metrics -->
        <tr>
          <th class="h2">{{ $t("global.bandwidth") }}:</th>
          <td>
            <div class="progress bg-transparent position-relative">
              <div
                class="progress-bar percentage"
                role="progressbar"
                :style="`width:${getBandwidthPercentage()}%`"
                :aria-valuenow="getBandwidthPercentage()"
                aria-valuemin="0"
                aria-valuemax="100"
              />
              <div class="mt-3 justify-content-center d-flex position-absolute w-100">
                {{
                  $t("global.units-out-of-total", {
                    amount: usageMetrics.bandwidthUsedGb + " GB",
                    total: usageMetrics.bandwidthTotalGb + " GB",
                  })
                }}
              </div>
            </div>
          </td>
        </tr>
      </table>
    </template>
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import LoadingState from "@/components/display/LoadingState";

export default {
  name: "PlanMetrics",
  components: {
    Card,
    LoadingState,
    CardActionContent,
  },
  props: {
    label: String,
    site: {
      type: Object,
    },
    plan: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
    usageMetrics: {
      type: Object,
      required: true,
      validator: (value) => {
        let valid = true;

        const requiredFields = [
          "storageTotalGb",
          "storageUsedGb",
          "bandwidthUsedGb",
          "bandwidthTotalGb",
        ];

        Object.keys(value).forEach((fieldName) => {
          // verify that all required fields are present & and of type "number"
          valid = requiredFields.includes(fieldName) && typeof value[fieldName] === "number";
        });

        return !valid || value;
      },
    },
    autoscaleMetrics: {
      type: Object,
      validator: (value) => {
        let valid = true;

        const requiredFields = [
          "concurrentUsers",
          "totalConcurrentUsers",
          "totalConcurrentUsersScaled",
        ];

        Object.keys(value).forEach((fieldName) => {
          // verify that all required fields are present & and of type "number"
          valid = requiredFields.includes(fieldName) && typeof value[fieldName] === "number";
        });

        // check that "isScaled" is present and is a boolean
        valid = typeof value["isScaled"] === "boolean";

        return !valid || value;
      },
    },
  },
  setup(props) {
    // usage and autoscaling percentages (a number between 1 and 100)
    // these are for the progress bars in the service card
    const getDiskSpacePercentage = () =>
      Math.floor(props.usageMetrics.storageUsedGb / props.usageMetrics.storageTotalGb);
    const getBandwidthPercentage = () =>
      Math.floor(props.usageMetrics.bandwidthUsedGb / props.usageMetrics.bandwidthTotalGb);

    return {
      getDiskSpacePercentage,
      getBandwidthPercentage,
    };
  },
};
</script>
<style lang="scss" scoped>
table.plan-metrics {
  width: 100%;
  th {
    width: 50%;
  }
  td {
    width: 50%;
    height: 40px;

    div.progress {
      height: 80%;
      border-style: solid;
      border-radius: 5px;
      border-width: 2px;

      div.percentage {
        border-radius: 5px;
        border-width: 2px;
      }
    }
  }
}
</style>
